/**
 * usePropertyTimezone
 * Hook to access the property's IANA timezone string.
 * Must be used within a PropertyTimezoneProvider.
 */

import { useContext } from 'react';
import { PropertyTimezoneContext } from '../contexts/propertyTimezone.context.js';

export function usePropertyTimezone(): string {
  const ctx = useContext(PropertyTimezoneContext);
  if (ctx === undefined) {
    throw new Error('usePropertyTimezone must be used within a PropertyTimezoneProvider');
  }
  return ctx.timezone;
}
